"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[6012],{

/***/ 14729:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85183);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52983);
/* harmony import */ var _util_contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84584);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var Link = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(props, ref) {
    var to = props.to, _props_href = props.href, href = _props_href === void 0 ? to : _props_href, children = props.children, onClick = props.onClick, _props_scroll = props.scroll, scroll = _props_scroll === void 0 ? true : _props_scroll, rest = _object_without_properties(props, [
        "to",
        "href",
        "children",
        "onClick",
        "scroll"
    ]);
    var history = (0,_util_contexts__WEBPACK_IMPORTED_MODULE_3__/* .useHistory */ .k6)();
    var handleClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(event) {
        // ignores the navigation when clicked using right mouse button or
        // by holding a special modifier key: ctrl, command, win, alt, shift
        if (event.ctrlKey || event.metaKey || event.altKey || event.shiftKey || event.button !== 0) {
            return;
        }
        if (typeof onClick === "function") {
            onClick(event);
        }
        if (!event.defaultPrevented) {
            event.preventDefault();
            history.push(href, {
                scroll: scroll
            });
        }
    }, [
        history,
        href,
        onClick,
        scroll
    ]);
    // wraps children in `a` if needed
    var extraProps = _object_spread_props(_object_spread({}, rest), {
        href: href,
        onClick: handleClick
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", _object_spread_props(_object_spread({}, extraProps), {
        ref: ref,
        children: children
    }));
});
Link.displayName = "Link";
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Link);


/***/ }),

/***/ 68964:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73281);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17376);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57890);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59690);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52983);
/* harmony import */ var links__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54780);
/* harmony import */ var _util_contexts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84584);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}







var Redirect = function(param) {
    var to = param.to, searchParams = param.searchParams, customWithSearch = param.withSearch, match = param.match, _param_code = param.code, code = _param_code === void 0 ? 302 : _param_code;
    var history = (0,_util_contexts__WEBPACK_IMPORTED_MODULE_5__/* .useHistory */ .k6)();
    var _useSearchParams = _sliced_to_array((0,_util_contexts__WEBPACK_IMPORTED_MODULE_5__/* .useSearchParams */ .lr)(), 1), existingSearchParams = _useSearchParams[0];
    var isRedirected = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(false);
    var params = (match === null || match === void 0 ? void 0 : match.params) || {};
    // ATTN we must save utm params on server side, because we register them on the client-side
    var withSearch =  false || customWithSearch;
    var redirect = function() {
        if (isRedirected.current) {
            return null;
        }
        var link = to;
        // if Redirect rendered by Switch, there will be always "params" so we should check keys
        if (Object.keys(params).length) {
            link = (0,links__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(to, params);
        }
        var options = {
            code: code
        };
        if (withSearch) {
            options.searchParams = _object_spread({}, existingSearchParams, searchParams);
        }
        history.replace(link, options);
        isRedirected.current = true;
    };
    if (true) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
            redirect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
    } else {}
    return null;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Redirect);


/***/ }),

/***/ 33996:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73281);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17376);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52983);
/* harmony import */ var _util_contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84584);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var Route = function(_param) {
    var children = _param.children, path = _param.path, match = _param.match, Component = _param.component, props = _object_without_properties(_param, [
        "children",
        "path",
        "match",
        "component"
    ]);
    if (!match) {
        return null;
    }
    // `props.match` is present - Route is controlled by the Switch
    var params = match.params;
    var routeChildren;
    // React-Router style `component` prop
    if (Component) {
        routeChildren = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, _object_spread({}, props));
    } else {
        routeChildren = children;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_util_contexts__WEBPACK_IMPORTED_MODULE_4__/* .RouteParamsContext */ .O2.Provider, {
        value: params,
        children: routeChildren
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Route);


/***/ }),

/***/ 48826:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ router_Router)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__(81738);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(17376);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__(6135);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(51497);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(35570);
// EXTERNAL MODULE: ./local_modules/router/util/searchParams.ts
var util_searchParams = __webpack_require__(87956);
;// CONCATENATED MODULE: ./local_modules/router/util/useLocationHook.ts
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}







// While History API does have `popstate` event, the only
// proper way to listen to changes via `push/replaceState`
// is to monkey-patch these methods.
//
// See https://stackoverflow.com/a/4585031
var patched;
var patchHistoryEvents = function() {
    if (patched) {
        return;
    }
    [
        "pushState",
        "replaceState"
    ].forEach(function(type) {
        var original = history[type];
        history[type] = function() {
            var result = original.apply(history, arguments);
            var event = new Event(type);
            // @ts-ignore
            event["arguments"] = arguments;
            window.dispatchEvent(event);
            return result;
        };
    });
    patched = true;
};
var useLocationHook = function() {
    var _useState = _sliced_to_array((0,react.useState)(location.pathname), 2), pathname = _useState[0], setPathname = _useState[1];
    var _useState1 = _sliced_to_array((0,react.useState)((0,util_searchParams/* getSearchParams */.Qw)(location.search)), 2), searchParams = _useState1[0], setSearchParams = _useState1[1];
    var lastPath = (0,react.useRef)(location.pathname);
    var lastSearch = (0,react.useRef)(location.search);
    var prevPath = (0,react.useRef)(null);
    var prevSearch = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        patchHistoryEvents();
        // this function checks if the location has been changed since the
        // last render and updates the state only when needed.
        // unfortunately, we can't rely on `path` value here, since it can be stale,
        // that's why we store the last pathname in a ref.
        var checkForUpdates = function() {
            // save last path as previous path
            prevPath.current = lastPath.current;
            prevSearch.current = lastSearch.current;
            var _window_location = window.location, pathname = _window_location.pathname, search = _window_location.search;
            if (lastPath.current !== pathname || lastSearch.current !== search) {
                (0,react.startTransition)(function() {
                    if (lastPath.current !== pathname) {
                        lastPath.current = pathname;
                        setPathname(pathname);
                    }
                    if (lastSearch.current !== search) {
                        lastSearch.current = search;
                        setSearchParams((0,util_searchParams/* getSearchParams */.Qw)(search));
                    }
                });
            }
        };
        var events = [
            "popstate",
            "pushState",
            "replaceState"
        ];
        events.forEach(function(event) {
            return window.addEventListener(event, checkForUpdates);
        });
        // it's possible that an setPath has occurred between render and the effect handler,
        // so we run additional check on mount to catch these updates. Based on:
        // https://gist.github.com/bvaughn/e25397f70e8c65b0ae0d7c90b731b189
        checkForUpdates();
        return function() {
            events.forEach(function(event) {
                return window.removeEventListener(event, checkForUpdates);
            });
        };
    }, []);
    var currentUrl = "".concat(lastPath.current).concat(lastSearch.current);
    var previousUrl = prevPath.current ? "".concat(prevPath.current).concat(prevSearch.current || "") : null;
    return {
        pathname: pathname,
        search: lastSearch.current,
        searchParams: searchParams,
        currentUrl: currentUrl,
        previousUrl: previousUrl
    };
};
/* harmony default export */ const util_useLocationHook = (useLocationHook);

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(5119);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(94218);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__(96837);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(28950);
// EXTERNAL MODULE: ../../node_modules/.pnpm/path-to-regexp@6.2.1/node_modules/path-to-regexp/dist.es2015/index.js
var dist_es2015 = __webpack_require__(53249);
;// CONCATENATED MODULE: ./local_modules/router/util/createMatcher.ts







function createMatcher() {
    var cache = {};
    // obtains a cached regexp version of the pattern
    var getRegexp = function(pattern) {
        if (!cache[pattern]) {
            var keys = [];
            var regexp = (0,dist_es2015/* pathToRegexp */.Bo)(pattern, keys);
            cache[pattern] = {
                regexp: regexp,
                keys: keys
            };
        }
        return cache[pattern];
    };
    return function(pattern, path) {
        var _getRegexp = getRegexp(pattern || ""), regexp = _getRegexp.regexp, keys = _getRegexp.keys;
        var out = regexp.exec(path);
        if (!out) {
            return null;
        }
        // formats an object with matched params
        var params = keys.reduce(function(params, key, i) {
            params[key.name] = out[i + 1];
            return params;
        }, {});
        return {
            path: pattern,
            params: params
        };
    };
}

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(59690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/web.timers.js
var web_timers = __webpack_require__(73598);
;// CONCATENATED MODULE: ./local_modules/router/util/createHistory.ts
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




var createHistory_navigate = function(param) {
    var to = param.to, searchParams = param.searchParams, title = param.title, state = param.state, replace = param.replace, _param_scroll = param.scroll, scroll = _param_scroll === void 0 ? true : _param_scroll;
    var href = searchParams ? (0,util_searchParams/* mergeSearchParams */.b4)(to, searchParams) : to;
    window.history[replace ? "replaceState" : "pushState"](state || null, title || null, href);
    if (scroll) {
        // Move to macro-task to fix scrolling for mobile
        setTimeout(function() {
            window.scrollTo(0, 0);
        }, 10);
    }
};
var createHistory = function() {
    return {
        push: function(to) {
            var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return createHistory_navigate(_object_spread_props(_object_spread({}, options), {
                to: to,
                replace: false
            }));
        },
        replace: function(to) {
            var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return createHistory_navigate(_object_spread_props(_object_spread({}, options), {
                to: to,
                replace: true
            }));
        }
    };
};
/* harmony default export */ const util_createHistory = (createHistory);

// EXTERNAL MODULE: ./local_modules/router/util/contexts.ts
var contexts = __webpack_require__(84584);
;// CONCATENATED MODULE: ./local_modules/router/Router.tsx









var buildRouter = function() {
    var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return {
        locationHook: opts.locationHook || util_useLocationHook,
        history: opts.history || util_createHistory(),
        matcher: createMatcher()
    };
};
var Router = function(props) {
    var routerRef = (0,react.useRef)(null);
    var pathnameRef = (0,react.useRef)(null);
    var searchParamsRef = (0,react.useRef)(null);
    if (!routerRef.current) {
        routerRef.current = buildRouter(props);
    }
    var locationState = routerRef.current.locationHook();
    var pathname = locationState.pathname, search = locationState.search, searchParams = locationState.searchParams;
    pathnameRef.current = pathname;
    searchParamsRef.current = searchParams;
    var setSearchParamsRef = (0,react.useRef)(null);
    if (!setSearchParamsRef.current) {
        setSearchParamsRef.current = function(input) {
            var historyReplace = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, scroll = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
            var newSearchParams = typeof input === "function" ? input(searchParamsRef.current) : input;
            routerRef.current.history[historyReplace ? "replace" : "push"](pathnameRef.current, {
                searchParams: newSearchParams,
                scroll: scroll
            });
        };
    }
    // to fix useSearchParams rerender on pathname change
    var searchParamsState = (0,react.useMemo)(function() {
        return [
            searchParams,
            setSearchParamsRef.current
        ];
    }, [
        searchParams
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(contexts/* RouterContext */._q.Provider, {
        value: routerRef.current,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contexts/* LocationStateContext */.WV.Provider, {
            value: locationState,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contexts/* PathnameContext */.kS.Provider, {
                value: pathname,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contexts/* SearchContext */.ci.Provider, {
                    value: search,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contexts/* SearchParamsContext */.mm.Provider, {
                        value: searchParamsState,
                        children: props.children
                    })
                })
            })
        })
    });
};
/* harmony default export */ const router_Router = (Router);


/***/ }),

/***/ 33675:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40963);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51497);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73074);
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85183);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_reverse_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22175);
/* harmony import */ var core_js_modules_es_array_reverse_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reverse_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96837);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52983);
/* harmony import */ var _util_contexts__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84584);








var Switch = function(props) {
    var children = props.children, location = props.location, onChange = props.onChange;
    var matcher = (0,_util_contexts__WEBPACK_IMPORTED_MODULE_7__/* .useRouter */ .tv)().matcher;
    var originalPathname = (0,_util_contexts__WEBPACK_IMPORTED_MODULE_7__/* .usePathname */ .jD)();
    var nodesToRender = [];
    var match;
    var matchRoutes = function(children) {
        react__WEBPACK_IMPORTED_MODULE_6__.Children.toArray(children).some(function(child) {
            if (match) {
                return true;
            }
            if (/*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_6__.isValidElement)(child)) {
                if (child.props.path) {
                    if (child.props.path === "*") {
                        match = {
                            path: "*",
                            params: {}
                        };
                        nodesToRender.push(child);
                        return;
                    }
                    var result = matcher(child.props.path, location || originalPathname);
                    // if pathname match route path then add Route to nodesToRender
                    if (result) {
                        match = result;
                        nodesToRender.push(child);
                    }
                } else {
                    // if node is Layout then add it to nodesToRender
                    nodesToRender.push(child);
                    // and iterate again
                    matchRoutes(child.props.children);
                    // if in nested routes no match then remove added Layout (move up by tree)
                    if (!match) {
                        nodesToRender.pop();
                    }
                }
            }
        });
    };
    matchRoutes(children);
    if (match) {
        if (typeof onChange === "function") {
            onChange(match);
        }
        nodesToRender.reverse();
        return nodesToRender.reduce(function(result, node) {
            // render route
            if (!result) {
                return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_6__.cloneElement)(node, {
                    match: match
                });
            }
            // render layout
            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_6__.cloneElement)(node, {
                match: match
            }, result);
        }, null);
    }
    return null;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Switch);


/***/ }),

/***/ 84584:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   KJ: () => (/* binding */ useLocationState),
/* harmony export */   O2: () => (/* binding */ RouteParamsContext),
/* harmony export */   Rx: () => (/* binding */ useSearch),
/* harmony export */   UO: () => (/* binding */ useParams),
/* harmony export */   WV: () => (/* binding */ LocationStateContext),
/* harmony export */   _q: () => (/* binding */ RouterContext),
/* harmony export */   ci: () => (/* binding */ SearchContext),
/* harmony export */   jD: () => (/* binding */ usePathname),
/* harmony export */   k6: () => (/* binding */ useHistory),
/* harmony export */   kS: () => (/* binding */ PathnameContext),
/* harmony export */   lr: () => (/* binding */ useSearchParams),
/* harmony export */   mm: () => (/* binding */ SearchParamsContext),
/* harmony export */   tv: () => (/* binding */ useRouter)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);

var RouterContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
var useRouter = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(RouterContext);
};
var useHistory = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(RouterContext).history;
};
var PathnameContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)("");
var usePathname = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(PathnameContext);
};
var SearchParamsContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)([
    {},
    function() {}
]);
var useSearchParams = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SearchParamsContext);
};
var SearchContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
var useSearch = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SearchContext);
};
var RouteParamsContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var useParams = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(RouteParamsContext);
};
var LocationStateContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
var useLocationState = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(LocationStateContext);
};


/***/ }),

/***/ 87956:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Qw: () => (/* binding */ getSearchParams),
/* harmony export */   b4: () => (/* binding */ mergeSearchParams)
/* harmony export */ });
/* harmony import */ var core_js_modules_web_url_search_params_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60189);
/* harmony import */ var core_js_modules_web_url_search_params_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_search_params_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_web_url_search_params_delete_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48458);
/* harmony import */ var core_js_modules_web_url_search_params_delete_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_search_params_delete_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_web_url_search_params_has_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42342);
/* harmony import */ var core_js_modules_web_url_search_params_has_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_search_params_has_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_web_url_search_params_size_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54967);
/* harmony import */ var core_js_modules_web_url_search_params_size_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_search_params_size_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5119);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94218);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40045);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51497);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6135);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(73281);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17376);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(35570);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_error_to_string_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86011);
/* harmony import */ var core_js_modules_es_error_to_string_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_to_string_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(45942);
/* harmony import */ var core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(61737);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(59690);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_15__);
















// TODO it doesn't work with arrays - added on 2021-12-22 by maddoger
var getSearchParams = function(search) {
    var params = {};
    new URLSearchParams(search).forEach(function(value, key) {
        params[key] = value;
    });
    return params;
};
var mergeSearchParams = function(url, searchParams) {
    var match = url.match(/^(.*?)(|\?.*?)$/);
    // if we can't parse the url, just replace it with a default one
    if (!match) {
        return "/";
    }
    var pathname = match[1];
    var params = new URLSearchParams(match[2]);
    // TODO check if it works with arrays - added on 2022-02-22 by maddoger
    // @ts-ignore
    var newParams = new URLSearchParams(searchParams);
    newParams.forEach(function(value, name) {
        if (value !== undefined && value !== null && typeof value !== "undefined" && value !== "undefined" && value !== "null") {
            params.set(name, value);
        } else {
            params["delete"](name);
        }
    });
    // delete redirect param if we're already on it
    if (params.has("redirect") && params.get("redirect") === pathname) {
        params["delete"]("redirect");
    }
    // delete tokens from redirect url for security reasons
    // params.delete('ltn') // keep for sentry
    // params.delete('magicToken')
    // replace `?` without params
    return "".concat(pathname, "?").concat(params.toString()).replace(/\?$/, "");
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (getSearchParams)));


/***/ })

}]);